export default __webpack_public_path__ + "static/media/id.ffa58d55.svg";